import type { ReactNode } from "react";
import { CheckCircle2, AlertCircle, Info } from "lucide-react";
import { cn } from "../../lib/utils";

/** 表單訊息列（錯誤／成功／提示）— 樣式沿用登入頁錯誤框，不引入 toast 系統 */
export function FormNotice({ kind, children, className }: { kind: "error" | "success" | "info"; children: ReactNode; className?: string }) {
  const Icon = kind === "error" ? AlertCircle : kind === "success" ? CheckCircle2 : Info;
  return (
    <div
      role={kind === "error" ? "alert" : "status"}
      className={cn(
        "flex items-start gap-2 rounded-md border px-3 py-2 text-[12px] leading-relaxed",
        kind === "error" &&
          "border-[color-mix(in_oklab,var(--color-destructive)_30%,transparent)] bg-destructive-soft text-destructive",
        kind === "success" &&
          "border-[color-mix(in_oklab,var(--color-success)_30%,transparent)] bg-[color-mix(in_oklab,var(--color-success)_12%,transparent)] text-[var(--color-success)]",
        kind === "info" && "border-border bg-muted text-muted-foreground",
        className,
      )}
    >
      <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
